import { Link } from "@mui/material";

export const MobileActions = () => {
  return <div>
    <Link href="/mobile">Back</Link>
    Just kidding!
  </div>;
};
